import { useState } from 'react';

export type UseTapped = {
  isTapped: boolean;
  handlers: {
    onTouchStart: () => void;
    onTouchEnd: () => void;
    onTouchCancel: () => void;
  };
};

const useTapped = (): UseTapped => {
  const [isTapped, setIsTapped] = useState(false);

  const handlers = {
    onTouchStart: () => setIsTapped(true),
    onTouchEnd: () => setIsTapped(false),
    onTouchCancel: () => setIsTapped(false),
  };

  return { isTapped, handlers };
};

export default useTapped;
